import { InputLabelSettings } from './types';

const commonSettings = {
  fontWeight: 2,
  fontFamily: 'secondary',
  gap: '1',
};

export const inputLabelSettings: InputLabelSettings = {
  componentVariants: {
    size: {
      prop: 'size',
      variants: {
        small: {
          fontSize: '0',
          lineHeight: '0',
          ...commonSettings,
        },
        medium: {
          fontSize: '1',
          lineHeight: '1',
          ...commonSettings,
        },
      },
    },
    color: {
      prop: 'color',
      variants: {
        primary: {
          color: 'primary.extraDark',
        },
        danger: {
          color: 'danger.main',
        },
        gray: {
          color: 'gray.main',
        },
      },
    },
  },
};
